var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"placeholder":_vm.placeholder},on:{"select":_vm.change},model:{value:(_vm.selfvalue),callback:function ($$v) {_vm.selfvalue=$$v},expression:"selfvalue"}},_vm._l((_vm.dictOptions),function(item){return _c('a-select-option',{key:item.itemKey,attrs:{"value":item.itemKey}},[_vm._v(" "+_vm._s(item.itemValue)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }